import { render, staticRenderFns } from "./othersStat.vue?vue&type=template&id=39892fc3&scoped=true"
import script from "./othersStat.vue?vue&type=script&lang=ts"
export * from "./othersStat.vue?vue&type=script&lang=ts"
import style0 from "./othersStat.vue?vue&type=style&index=0&id=39892fc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39892fc3",
  null
  
)

export default component.exports